import { c as _c } from "react/compiler-runtime";
import { EmptyPage } from "@components/common/empty-page/empty-page";
import { EntitiesToolbar } from "@components/common/toolbar/entities-toolbar";
import { SelectWorkspaceItem } from "@components/common/workspace/select-workspace-item";
import { MainPageLayout } from "@components/page-layout/main-page-layout";
import { Grid } from "@mui-wrapper";
import { NoWorkspace } from "@pages/workspace/no-workspace";
import { fetchingSdbCompanyFlagsSelector, filteredSdbCompaniesSelector, sdbCompaniesSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { Divider, SearchDuoIcon } from "@flat-ui";
import { sortWorkspaces } from "@utils/sdb-company-utils";
import { WorkspaceEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";

/** The number of skeletons to show when there are no workspaces.  */
const NUMBER_OF_SKELETONS = 4;

/** Array of skeletons to show when there are no workspaces. */
const skeletonsArray = new Array(NUMBER_OF_SKELETONS).fill(null).map((_, index) => <SelectWorkspaceItem key={`skeleton-${index}`} isEven={index % 2 === 0}
// If no company is provided, it shows an skeleton by default
/>);
export function SelectWorkspacePage() {
  const $ = _c(19);
  const sdbCompanies = useAppSelector(sdbCompaniesSelector);
  const filteredSdbCompanies = useAppSelector(filteredSdbCompaniesSelector);
  const {
    isFetchingSdbCompanies
  } = useAppSelector(fetchingSdbCompanyFlagsSelector);
  const {
    trackEvent
  } = useTrackEvent();
  const hasWorkspaces = sdbCompanies.length > 0;
  const hasNoSearchResults = hasWorkspaces && filteredSdbCompanies.length === 0 && !isFetchingSdbCompanies;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      minHeight: "100vh",
      backgroundColor: "surfaces.secondary",
      position: "relative",
      overflow: "hidden"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      marginTop: "55px"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== filteredSdbCompanies.length || $[3] !== hasWorkspaces) {
    t2 = hasWorkspaces && <><Grid sx={{
        color: "text.primary",
        fontSize: "32px",
        fontWeight: "500",
        lineHeight: "44px",
        letterSpacing: "2.5"
      }} size={12}>All Workspaces<Divider sx={{
          marginTop: "13px"
        }} /></Grid><Grid size={12}><EntitiesToolbar toolbarEntityName="Workspace" numberOfRows={filteredSdbCompanies.length} /></Grid></>;
    $[2] = filteredSdbCompanies.length;
    $[3] = hasWorkspaces;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== filteredSdbCompanies || $[6] !== trackEvent) {
    t3 = filteredSdbCompanies.length > 0 && filteredSdbCompanies.sort(sortWorkspaces).map((sdbCompany, index) => <SelectWorkspaceItem key={sdbCompany.id} sdbCompany={sdbCompany} isEven={index % 2 === 0} onWorkspaceClick={() => {
      trackEvent({
        name: WorkspaceEvents.selectWorkspace,
        props: {
          numberOfWorkspaces: filteredSdbCompanies.length
        }
      });
    }} />);
    $[5] = filteredSdbCompanies;
    $[6] = trackEvent;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = !hasWorkspaces && skeletonsArray;
  let t5;
  if ($[8] !== hasWorkspaces || $[9] !== isFetchingSdbCompanies) {
    t5 = !hasWorkspaces && !isFetchingSdbCompanies && <NoWorkspace />;
    $[8] = hasWorkspaces;
    $[9] = isFetchingSdbCompanies;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== hasNoSearchResults) {
    t6 = hasNoSearchResults && <Grid size={12}><EmptyPage title="No results found" subtitle="There are no workspaces that match this search." icon={SearchDuoIcon} /></Grid>;
    $[11] = hasNoSearchResults;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
    t7 = <Grid container={true} sx={t0}><MainPageLayout shouldShowSidebar={false} shouldShowLogo={true} shouldHideOpenButton={true}><Grid container={true} sx={t1}>{t2}{t3}{t4}{t5}{t6}</Grid></MainPageLayout></Grid>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}